import { View } from 'react-native';
import { tv } from '@/common/theme/tv.config';

export const Divider = ({ className }: TDividerProps) => {
  return <View className={styles.root({ className })} />;
};

export type TDividerProps = {
  className?: string;
};

const styles = {
  root: tv({
    base: 'h-[0.1rem] w-full bg-neutral30',
  }),
};
